// @ts-ignore
import polygonPolygon from 'intersects/polygon-polygon';
// @ts-ignore
import polygonPoint from 'intersects/polygon-point';

const polygonPointBoolean = (area: any, points: any) => {
  return polygonPoint(area.flat(), points[0], points[1], 1e-6);
};

export function checkWarehouseIntersection(
  polygon: number[][],
  restrictedAreas: number[][][],
  restrictedAreasStationary: number[],
) {
  for (const area of restrictedAreas) {
    if (polygonPolygon(polygon.flat(), area.flat())) return true;
  }
  for (const points of restrictedAreasStationary) {
    if (polygonPointBoolean(polygon, points)) return true;
  }

  return false;
}

export function checkWarehouseIntersectionByPoint(
  points: number[],
  restrictedAreas: number[][][],
) {
  for (const area of restrictedAreas) {
    if (polygonPointBoolean(area, points)) return true; // 10^-6
  }

  return false;
}
